import React from 'react'
import ReactDOM from 'react-dom'
import classNames from 'classnames'
import Dialog from './index'
import ActionButton from './ActionButton'
import Checkbox from '@components/common/Checkbox'

const IS_REACT_16 = !!ReactDOM.createPortal
export const destroyFns = []

/* eslint-disable react/prop-types */
class ConfirmDialog extends React.Component {
  state = {
    checked: false
  }

  render() {
    const {
      onCancel,
      onOk,
      close,
      zIndex,
      afterClose,
      visible,
      keyboard,
      centered = true,
      getContainer,
      maskStyle,
      okButtonProps,
      cancelButtonProps,
      iconType = 'icon-tip',
      dark,
      checkbox,
    } = this.props

    const icon = this.props.icon ? this.props.icon : iconType
    const okType = this.props.okType || 'primary'
    const prefixCls = this.props.prefixCls || 'ant-modal'
    const contentPrefixCls = `${prefixCls}-confirm`
    // 默认为 true，保持向下兼容
    const okCancel = 'okCancel' in this.props ? this.props.okCancel : true
    const width = this.props.width || 450
    const style = this.props.style || {}
    const mask = this.props.mask === undefined ? true : this.props.mask
    // 默认为 false，保持旧版默认行为
    const maskClosable = this.props.maskClosable === undefined ? false : this.props.maskClosable
    const { okText, cancelText } = this.props
    const autoFocusButton = this.props.autoFocusButton === null ? false : this.props.autoFocusButton || 'ok'
    const transitionName = this.props.transitionName || 'zoom'
    const maskTransitionName = this.props.maskTransitionName || 'fade'

    const classString = classNames(
      contentPrefixCls,
      `${contentPrefixCls}-${this.props.type}`,
      this.props.className,
      {
        'dark-theme': dark
      }
    )

    const cancelButton = okCancel && (
      <ActionButton
        actionFn={onCancel}
        closeModal={close}
        autoFocus={autoFocusButton === 'cancel'}
        buttonProps={cancelButtonProps}
      >
        {cancelText}
      </ActionButton>
    )

    const iconNode = typeof icon === 'string' ? <i className={`iconfont ${icon}`}/> : icon

    const { checked } = this.state

    const okHandler = checkbox ? (...rest) => {
      if (checked) {
        onOk(...rest)
      }
    } : onOk

    return (
      <Dialog
        prefixCls={prefixCls}
        className={classString}
        wrapClassName={classNames({ [`${contentPrefixCls}-centered`]: !!this.props.centered })}
        onCancel={close.bind(this, { triggerCancel: true })}
        visible={visible}
        title=""
        transitionName={transitionName}
        footer=""
        maskTransitionName={maskTransitionName}
        mask={mask}
        maskClosable={maskClosable}
        maskStyle={maskStyle}
        style={style}
        width={width}
        zIndex={zIndex}
        afterClose={afterClose}
        keyboard={keyboard}
        centered={centered}
        getContainer={getContainer}
      >
        <div className={`${contentPrefixCls}-body-wrapper`}>
          <div className={`${contentPrefixCls}-body`}>
            {iconNode}
            <span className={`${contentPrefixCls}-title`}>{this.props.title}</span>
            <div className={`${contentPrefixCls}-content`}>
              {checkbox && <Checkbox dark={dark} checked={checked} onChange={this.handleChecked}/>}
              {this.props.content}
            </div>
          </div>
          <div className={`${contentPrefixCls}-btns`}>
            {cancelButton}
            <ActionButton
              type={okType}
              actionFn={okHandler}
              closeModal={close}
              autoFocus={autoFocusButton === 'ok'}
              buttonProps={{ ...okButtonProps, disabled: checkbox && !checked }}
            >
              {okText}
            </ActionButton>
          </div>
        </div>
      </Dialog>
    )
  }

  handleChecked = (e) => {
    this.setState({
      checked: e && e.target && e.target.checked
    })
  }
}

ConfirmDialog.defaultProps = {
  okText: '确认',
  cancelText: '取消',
}

export default function confirm(config) {
  const div = document.createElement('div')
  document.body.appendChild(div)

  function render({ Component, ...props }) {
    if (Component) {
      if (props.afterClose) {
        props.afterClose()
      } else {
        const { close: closeFn, visible, ...rest } = props
        ReactDOM.render(<Component {...rest} modal={{ close: closeFn, visible }}/>, div)
      }
    } else {
      ReactDOM.render(<ConfirmDialog {...props} />, div)
    }
  }

  function destroy(...args) {
    const unmountResult = ReactDOM.unmountComponentAtNode(div)
    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div)
    }
    const triggerCancel = args.some(param => param && param.triggerCancel)
    if (config.onCancel && triggerCancel) {
      config.onCancel(...args)
    }
    for (let i = 0; i < destroyFns.length; i++) {
      const fn = destroyFns[i]
      /* eslint-disable no-use-before-define */
      if (fn === close) {
        destroyFns.splice(i, 1)
        break
      }
    }
  }

  let currentConfig = { ...config, close, visible: true }

  function close(...args) {
    currentConfig = {
      ...currentConfig,
      visible: false,
      afterClose: destroy.bind(this, ...args),
    }
    if (IS_REACT_16) {
      render(currentConfig)
    } else {
      destroy(...args)
    }
  }

  function update(newConfig) {
    currentConfig = {
      ...currentConfig,
      ...newConfig,
    }
    render(currentConfig)
  }

  render(currentConfig)

  destroyFns.push(close)

  return {
    destroy: close,
    update,
  }
}
